import { MOTActionTypes } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const vehicleStatus = createAsyncMapAction(MOTActionTypes.VEHICLE_STATUS, p => p.vehicleId);
